import styled from 'styled-components';

export const SReactSpinePlayer = styled.div`
  position: absolute;
  background-size: contain;
  width: 100%;
  height: 200px;
  top: -18px;
  z-index: 0;
  pointer-events: none;

  @media (max-width: 854px) and (max-aspect-ratio: 1/1) {
    top: -38px;
  }

  @media (max-width: 600px) and (max-aspect-ratio: 1/1) {
    width: 450px;
    left: 50%;
    transform: translateX(-50%);
    top: -35px;
  }

  @media (max-width: 450px) and (max-aspect-ratio: 1/1) {
    width: 400px;
    top: -58px;
  }

  @media (max-width: 410px) and (max-aspect-ratio: 1/1) {
    width: 380px;
    top: -56px;
  }

  @media (max-width: 360px) and (max-aspect-ratio: 1/1) {
    width: 360px;
    top: -53px;
  }
`;
